import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { mergeDeep } from 'immutable';
import { initReactI18next } from 'react-i18next';

import { LOCALE_LSK } from '@app/config/localstorage-keys.const';

import cpmsEn from './en.json';
import cpmsFr from './fr.json';
import cpmsIt from './it.json';
import { DEFAULT_NAMESPACE, LOCALE_KEYS } from './locale';

// import.meta.glob() replaces webpack's require.context() — Vite requires a static string
// literal per call, hence one glob call per source instead of a parameterized helper.
function mergeGlob(modules: Record<string, unknown>) {
  return Object.entries(modules).reduce(
    (acc, [key, data]) => {
      const match = /\.i18n-(fr|en|it)\.json$/.exec(key);
      if (!match) return acc;
      const lang = match[1]!;
      acc[lang] = mergeDeep(acc[lang] ?? {}, data as Record<string, any>);
      return acc;
    },
    {} as Record<string, any>,
  );
}

const sharedDesignSystemReactLocales = mergeGlob(
  import.meta.glob(
    '../../../node_modules/@delmonicos/shared-design-system-react/src/**/*.i18n-{fr,en,it}.json',
    { eager: true, import: 'default' },
  ),
);

const sharedSdkLocales = mergeGlob(
  import.meta.glob(
    '../../../node_modules/@delmonicos/shared-sdk/libs/cpms/src/**/*.i18n-{fr,en,it}.json',
    { eager: true, import: 'default' },
  ),
);

const cpmsBackOfficeWebLocales = mergeGlob(
  import.meta.glob('../../**/*.i18n-{fr,en,it}.json', {
    eager: true,
    import: 'default',
  }),
);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    defaultNS: DEFAULT_NAMESPACE,
    resources: {
      [LOCALE_KEYS.en]: {
        translation: mergeDeep(
          sharedSdkLocales.en,
          sharedDesignSystemReactLocales.en,
          cpmsEn,
          cpmsBackOfficeWebLocales.en,
        ),
      },
      [LOCALE_KEYS.fr]: {
        translation: mergeDeep(
          sharedSdkLocales.fr,
          sharedDesignSystemReactLocales.fr,
          cpmsFr,
          cpmsBackOfficeWebLocales.fr,
        ),
      },
      [LOCALE_KEYS.it]: {
        translation: mergeDeep(
          sharedSdkLocales.it,
          sharedDesignSystemReactLocales.it,
          cpmsIt,
          cpmsBackOfficeWebLocales.it,
        ),
      },
    },
    fallbackLng: [LOCALE_KEYS.fr, LOCALE_KEYS.en],
    interpolation: {
      escapeValue: false,
      defaultVariables: { errorCode: '0003' },
    },
    detection: {
      lookupLocalStorage: LOCALE_LSK,
      caches: [],
    },
  });

export default i18n;
